<template>
  <div class="folders">
    <div class="folders__content">
      <div class="folder-data__header">
        <div class="folder-data__nav-actions">
          <FoldersActions
            :folder="folder"
            @selectAll="toggleSelectAll"
            @deleteAll="deleteAll"
            @moveToFolder="moveToFolder"
          ></FoldersActions>
        </div>
      </div>

      <router-view :key="$route.path" ref="subfolder"></router-view>
    </div>
  </div>
</template>

<script>
import GET_ROOT_FOLDER from '@/graphql/GetRootFolder.gql'
import CHECK_FOLDER from '@/graphql/CheckFolder.gql'
/* import GET_SUBFOLDERS from '@/graphql/GetSubfolders.gql'
 */
import FoldersActions from '@/components/FoldersActions.vue'

export default {
  components: {
    FoldersActions,
  },

  data() {
    return {
      folder: {
        _id: null,
        name: null,
      },
      loading: true,
      notFound: false,
      error: false,
    }
  },

  computed: {
    isRoot() {
      return !this.$route.params.id
    },
  },

  watch: {
    $route() {
      this.checkFolderId()
    },
  },

  created() {
    this.checkFolderId()
  },

  methods: {
    async checkFolderId() {
      if (this.isRoot) {
        try {
          const res = await this.$apollo.query({
            query: GET_ROOT_FOLDER,
          })

          this.folder = res.data.rootFolder
        } catch (err) {
          console.log(err)
        }
      } else {
        try {
          const res = await this.$apollo.query({
            query: CHECK_FOLDER,
            variables: {
              id: this.$route.params.id,
            },
          })

          if (res.data.findFolderByID) {
            this.folder = res.data.findFolderByID
          } else {
            this.notFound = true
          }
        } catch (err) {
          this.error = true

          if (err.graphQLErrors && err.graphQLErrors.length) {
            if (
              err.graphQLErrors[0].extensions &&
              err.graphQLErrors[0].extensions.code === 'invalid argument'
            ) {
              this.notFound = true
            }
          }
          console.dir(err)
        }
      }

      this.loading = false
    },
    toggleSelectAll(checked) {
      this.$refs.subfolder.toggleSelectAll(checked)
    },
    deleteAll() {
      this.$refs.subfolder.$refs.folderData.deleteChecked()
    },
    moveToFolder() {
      this.$refs.subfolder.$refs.folderData.openMoveToFolder()
    },
  },
}
</script>
